import styled, {css, keyframes} from 'styled-components'

const blinkAnimation = keyframes`
    0%, 50% {
        opacity: 1;
    }
    51%, 100% {
        opacity: 0;
    }
`

const Style = {
	Wrapper: styled.div`
		display: grid;
		grid-template-columns: repeat(5, 1fr);
		gap: 40px;

		@media (max-width: 1200px) {
			gap: 17px;
			grid-template-columns: repeat(2, 1fr);
		}
	`,

	LevelTimeSection: styled.div`
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
		gap: 8px;
	`,

	LevelText: styled.p`
		${({theme}) => theme.font.extra_small_bold};
		color: ${({theme}) => theme.color.black};
		margin: 0;
		text-align: center;
		font-size: 18px;

		@media (max-width: ${({theme}) => theme.breakpoints.mobile}) {
			font-size: 14px;
		}
	`,

	TimeContainer: styled.div`
		display: flex;
		flex-direction: row;
		justify-content: center;
		align-items: center;
		gap: 10px;
		width: fit-content;
		padding: 3px 8px;
		height: 24px;
		border: 1px solid ${({theme}) => theme.color.grey2};
		border-radius: 99px;
		background-color: ${({theme}) => theme.color.white};
	`,

	TimeText: styled.p`
		${({theme}) => theme.font.small_bold};
		color: ${({theme}) => theme.color.black};
		margin: 0;
		line-height: 1;
		font-size: 20px;

		@media (max-width: ${({theme}) => theme.breakpoints.mobile}) {
			font-size: 14px;
		}
		${({$warning}) =>
			$warning &&
			css`
				color: red;
				animation: ${blinkAnimation} 1s infinite;
			`}
	`,

	InfoSection: styled.div`
		display: flex;
		flex-direction: column;
		align-items: center;
		gap: 8px;
	`,

	InfoLabel: styled.p`
		${({theme}) => theme.font.extra_small_bold};
		color: ${({theme}) => theme.color.black};
		margin: 0;
		text-align: center;
		white-space: nowrap;
		font-size: 14px;

		@media (max-width: ${({theme}) => theme.breakpoints.mobile}) {
			font-size: 11px;
		}
	`,

	InfoValue: styled.p`
		${({theme}) => theme.font.medium_bold};
		color: ${({theme}) => theme.color.black};
		margin: 0;
		text-align: center;
		white-space: nowrap;
		font-size: 20px;
	`,

	LoadingText: styled.p`
		${({theme}) => theme.font.extra_small};
		color: ${({theme}) => theme.color.grey4};
		margin: 0;
		text-align: center;
		width: 100%;
	`,
	TableVerticalElement: styled.div`
		width: 100%;
		border-bottom: 1px solid ${({theme}) => theme.color.grey2};
		display: flex;

		@media (max-width: ${({theme}) => theme.breakpoints.mobile}) {
			display: none;
		}
		& > h2 {
			display: flex;
			align-items: center;
			width: 200px;
			min-width: 200px;
			padding: 8px 16px;
			background-color: ${({theme}) => theme.color.grey1};
			${({theme}) => theme.font.extra_small_bold};

			& > span {
				${({theme}) => theme.font.extra_small_bold};
				color: ${({theme}) => theme.color.major};
			}

			@media (max-width: ${({theme}) => theme.breakpoints.mobile}) {
				width: 200px;
				min-width: 200px;
			}
		}

		& > input {
			width: 100%;
			padding: 8px 16px;
			margin: 6px 6px;
			${({theme}) => theme.font.extra_small};
			border: 1px solid ${({theme}) => theme.color.grey3};
			border-radius: 4px;

			@media (max-width: ${({theme}) => theme.breakpoints.mobile}) {
				margin: 3px 4px;
			}
		}

		input[type='number']:disabled {
			@media (max-width: ${({theme}) => theme.breakpoints.mobile}) {
				background: #eef0f2;
				cursor: not-allowed;
			}
		}

		& > select {
			width: 100%;
			padding: 8px 16px;
			margin: 6px 6px;
			${({theme}) => theme.font.extra_small};
			border: 1px solid ${({theme}) => theme.color.grey3};
			border-radius: 4px;

			@media (max-width: ${({theme}) => theme.breakpoints.mobile}) {
				margin: 3px 4px;
			}
		}

		& > textarea {
			height: 200px;
			flex-grow: 1;
			${({theme}) => theme.font.extra_small};
			padding: 8px 16px;
			margin: 6px 6px;
			border: 1px solid ${({theme}) => theme.color.grey3};
			border-radius: 4px;
		}
	`,
	Timer: styled.div`
		display: flex;
		align-items: center;
		width: 200px;
		min-width: 200px;
		padding: 8px 16px;
		background-color: ${({theme}) => theme.color.grey1};
		${({theme}) => theme.font.extra_small_bold};

		& > span {
			${({theme}) => theme.font.extra_small_bold};
			color: ${({theme}) => theme.color.major};
		}

		@media (max-width: ${({theme}) => theme.breakpoints.mobile}) {
			width: 66px;
			min-width: 66px;
		}
	`,
	BtnDefaultContainer: styled.div`
		width: 100%;
		display: flex;
		align-items: center;
		justify-content: flex-end;
		gap: 4px;
		flex-wrap: no-wrap;
		margin: 3px 4px;
	`,
}

export default Style
